<template>
  <div class="makecode-container">
    <StudentHeader :title="title" />

    <!-- 使用iframe嵌入外部网页 -->
    <iframe
      :src="iframeSrc"
      class="makecode-iframe"
      frameborder="0"
      allow="usb; fullscreen; camera; microphone; geolocation; clipboard-read; clipboard-write; speaker; vibrate"
    ></iframe>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRoute } from "vue-router"

import StudentHeader from "@/components/StudentHeader.vue"

const iframeSrc = ref("")
const route = useRoute()

// 加载iframe的方法
const loadIframe = () => {
  try {
    // 设置要嵌入的外部网页URL
    // 请根据实际情况修改这个URL
    const baseUrl = "https://microbit.teachmusic.cn/index.html"

    // 检查路由参数中是否有hex文件URL
    const hexUrl = route.query.hex

    if (hexUrl) {
      // 使用 hexurl 协议加载在线hex文件
      iframeSrc.value = `${baseUrl}#hexurl:${hexUrl}`
    } else if (route.query.taskId) {
      // 使用 pid 加载项目
      iframeSrc.value = `${baseUrl}#editor?pid=p${route.query.taskId}`
    } else {
      // 默认打开编辑器
      iframeSrc.value = `${baseUrl}#editor`
    }
  } catch (err) {
    console.error("加载iframe失败:", err)
  }
}

// 组件挂载时加载iframe
onMounted(() => {
  loadIframe()
})
</script>

<style scoped>
/* 样式保持不变 */
.makecode-container {
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
  position: relative;
}

.makecode-iframe {
  width: 100%;
  height: calc(100% - 2.87vw);
  border: none;
}
</style>
